const LoadHistoryDataType = {
  USER_DATA: 'USER',
  QUEUE_DATA: 'QUEUE'
};

export default LoadHistoryDataType;